import { render, staticRenderFns } from "./ImportNewItemPrice.vue?vue&type=template&id=6f780aa5&"
import script from "./ImportNewItemPrice.vue?vue&type=script&lang=js&"
export * from "./ImportNewItemPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports